import { COLORS, FONTS } from "@constants";
import { ReactNode } from "react";
import styled from "styled-components";

interface Props {
  font?: string;
  children: ReactNode;
  color?: string;
  margin?: string;
  padding?: string;
  as?: string;
}

/**
 * Generic text component that allows modifying the color and font.
 */
const Text = ({
  font = FONTS.REGULAR_2,
  children,
  color = COLORS.BLACK,
  margin,
  padding,
  as,
}: Props) => (
  <Container $font={font} $color={color} $margin={margin} $padding={padding} as={as}>
    {children}
  </Container>
);

export default Text;

const Container = styled.div`
  ${({ $font }) => $font};
  ${({ $margin }) => $margin && `margin: ${$margin};`};
  ${({ $padding }) => $padding && `padding: ${$padding};`};
  color: ${({ $color }) => $color};
`;
